// extracted by mini-css-extract-plugin
module.exports = {"product_shown":"ProductGrid_product_shown__3N6D7","load_more":"ProductGrid_load_more__kaO2H"};